'use client';

import { c as _c } from "react/compiler-runtime";
import { AppShellBootSkeleton } from '@/domains/dashboard/components/app-shell-boot-skeleton';
import { useAuthContext } from '@/hooks/use-auth';
import { isPlayground } from '@/utils/check-is-playground';
import { useAuth0 } from '@auth0/auth0-react';
import { PropsWithChildren } from 'react';
import { GenericErrorPage } from '../errors';
export const Auth0AuthenticatedLayout = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const {
    isLoading,
    isAuthenticated,
    loginWithRedirect,
    error
  } = useAuth0();
  const {
    loading: isAccessTokenLoading,
    jwt,
    error: authError,
    isSharedLink
  } = useAuthContext();
  const shouldRedirect = !isAuthenticated && !isPlayground();
  const waitingForAccessToken = isAuthenticated && (isAccessTokenLoading || !jwt) && !isPlayground();
  if (error || authError) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <GenericErrorPage />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (isLoading || waitingForAccessToken) {
    let t1;
    if ($[1] !== isSharedLink) {
      t1 = <div className="fadeIn h-screen w-full"><AppShellBootSkeleton isSharedLink={isSharedLink} /></div>;
      $[1] = isSharedLink;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (shouldRedirect) {
    loginWithRedirect();
    let t1;
    if ($[3] !== isSharedLink) {
      t1 = <div className="fadeIn h-screen w-full"><AppShellBootSkeleton isSharedLink={isSharedLink} /></div>;
      $[3] = isSharedLink;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  let t1;
  if ($[5] !== children) {
    t1 = <>{children}</>;
    $[5] = children;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};